import classNames from 'classnames';
import { OverlayTrigger } from 'react-bootstrap';
import { PopoverTooltipV2 as PopoverTooltip, TextButton } from '@praktio/common-ui';

import IconTooltip, { OptionalIconTooltipProps } from '../IconTooltip/IconTooltip';

import './TilePercentage.scss';

type ButtonProps = {
  text?: string;
  onClick?: () => void;
};

export type TilePercentageProps = {
  active?: boolean;
  heading?: string;
  tooltipProps?: OptionalIconTooltipProps;
  percentage?: number;
  count?: string;
  buttonProps?: ButtonProps;
  removeButtonProps?: ButtonProps;
  copyButtonProps?: Omit<ButtonProps, 'text'>;
};

const TilePercentage = ({
  active = false,
  heading,
  tooltipProps: { id, placement, text } = {},
  percentage = 0,
  count,
  buttonProps: { text: buttonText, onClick } = {},
  removeButtonProps: { text: removeButtonText, onClick: onRemoveClick } = {},
  copyButtonProps: { onClick: onCopyClick } = {},
}: TilePercentageProps) => {
  const noLearners = percentage === 0;

  const handleCopyClick = () => {
    // Copy emails to clipboard and filter table
    onCopyClick?.();
    onClick?.();
  };

  const renderFilterButton = () => {
    if (!onClick) return <></>;

    return (
      <TextButton disabled={noLearners} onClick={onClick}>
        <span className="material-symbols-sharp">filter_alt</span>
        {buttonText}
      </TextButton>
    );
  };

  return (
    <div
      className={classNames('TilePercentage', {
        'TilePercentage--active': active,
      })}
    >
      {!!heading && (
        <div className="TilePercentage__header">
          <h3 className="TilePercentage__heading">{heading}</h3>
          {!!id && !!text && <IconTooltip id={id} icon="help" text={text} placement={placement} />}
        </div>
      )}

      <p className="TilePercentage__percentage">{percentage}%</p>

      {!!count && (
        <div className="TilePercentage__count-container">
          <p className="TilePercentage__count">{count}</p>

          {percentage > 0 && (
            <button onClick={handleCopyClick}>
              <IconTooltip
                id={`${id}-copy-btn`}
                icon="content_copy"
                text="Copy these learner emails to your clipboard."
                placement={placement}
              />
            </button>
          )}
        </div>
      )}

      {active ? (
        !!onRemoveClick && (
          <TextButton onClick={onRemoveClick}>
            <span className="material-symbols-sharp">close</span>
            {removeButtonText}
          </TextButton>
        )
      ) : noLearners ? (
        <OverlayTrigger
          placement={placement}
          overlay={
            <PopoverTooltip
              id={`tooltip-filter-${id}`}
              paragraph="There are currently no learners under this tile category to filter."
            />
          }
        >
          {renderFilterButton()}
        </OverlayTrigger>
      ) : (
        renderFilterButton()
      )}
    </div>
  );
};

export default TilePercentage;
